<template>
<router-link class="nolink" :to="`/project/${project.id}/${project.slug}`">

  <v-card class="">
    <v-hover>
      <template v-slot:default="{ hover }">
    <v-img :aspect-ratio="16/9" :src="project.thumbnail_large">
      <v-row class="lightbox white--text pa-2 fill-height">
        <v-fade-transition>
          <v-overlay :absolute="true" :value="true" :opacity="0.6" v-if="hover">
            <v-btn color="primary" >
              <v-icon small>fa-play</v-icon>
            </v-btn>
          </v-overlay>
        </v-fade-transition>
      </v-row>
    </v-img>
  </template>
    </v-hover>
    <v-card-actions>
      <div>
        <h5 v-if="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'">{{this.project.title | limit_15}}</h5>
        <h5 v-else-if="$store.state.app.display ==='lg'">{{this.project.title | limit_50}}</h5>
        <h5 v-else>{{this.project.title | limit_35}}</h5>
      </div>
      <v-spacer>
      </v-spacer>
    </v-card-actions>
  </v-card>



</router-link>
</template>
<script>
export default {
  props: ['project'],
  name: "",
  data: () => ({

  })
}
</script>
<style lang="scss" scoped>
</style>
